export default [
  ...new Set([
    "Afrique",
    "Aiguille",
    "Aile",
    "Air",
    "Alien",
    "Allemagne",
    "Alpes",
    "Amérique",
    "Amour",
    "Ampoule",
    "Ange",
    "Angleterre",
    "Anneau",
    "Appareil",
    "Araignée",
    "Arc",
    "Argent",
    "Asile",
    "Astérix",
    "Atlantique",
    "Atout",
    "Australie",
    "Avion",
    "Avocat",
    "Baguette",
    "Baie",
    "Balance",
    "Baleine",
    "Balle",
    "Ballon",
    "Banane",
    "Banc",
    "Bande",
    "Banque",
    "Bar",
    "Barre",
    "Base",
    "Bateau",
    "Bâton",
    "Berlin",
    "Bête",
    "Bière",
    "Blé",
    "Boeuf",
    "Boîte",
    "Bombe",
    "Bon",
    "Botte",
    "Bouche",
    "Bouchon",
    "Bougie",
    "Boulet",
    "Bourse",
    "Bouteille",
    "Bouton",
    "Branche",
    "Bretelle",
    "Brique",
    "Bûche",
    "Bureau",
    "But",
    "Cabinet",
    "Cadre",
    "Cafard",
    "Café",
    "Camembert",
    "Canada",
    "Canard",
    "Canne",
    "Canon",
    "Carreau",
    "Carrière",
    "Carte",
    "Carton",
    "Cartouche",
    "Casino",
    "Ceinture",
    "Cellule",
    "Centre",
    "Cercle",
    "Chaîne",
    "Chambre",
    "Champ",
    "Champagne",
    "Champagne",
    "Chance",
    "Chapeau",
    "Charge",
    "Chasse",
    "Chat",
    "Château",
    "Chausson",
    "Chef",
    "Chemise",
    "Cheval",
    "Chevalier",
    "Chien",
    "Chine",
    "Chocolat",
    "Chou",
    "Cinéma",
    "Cirque",
    "Citrouille",
    "Classe",
    "Clé",
    "Club",
    "Cochon",
    "Code",
    "Coeur",
    "Col",
    "Colle",
    "Commerce",
    "Coq",
    "Corde",
    "Corne",
    "Coton",
    "Coupe",
    "Courant",
    "Couronne",
    "Course",
    "Court",
    "Couteau",
    "Couverture",
    "Critique",
    "Crochet",
    "Cuisine",
    "Cycle",
    "Danse",
    "Dinosaure",
    "Docteur",
    "Don",
    "Dragon",
    "Droite",
    "Droite",
    "Eau",
    "Échelle",
    "Éclair",
    "École",
    "Égalité",
    "Égypte",
    "Enceinte",
    "Ensemble",
    "Entrée",
    "Éponge",
    "Espace",
    "Espagne",
    "Espion",
    "Esprit",
    "Essence",
    "Étoile",
    "Étude",
    "Europe",
    "Facteur",
    "Fantôme",
    "Farce",
    "Fer",
    "Ferme",
    "Feu",
    "Feuille",
    "Figure",
    "Filet",
    "Fin",
    "Flûte",
    "Forêt",
    "Formule",
    "Fort",
    "Fou",
    "Foyer",
    "Fraise",
    "Français",
    "Front",
    "Fuite",
    "Garde",
    "Gauche",
    "Géant",
    "Gel",
    "Génie",
    "Glace",
    "Gorge",
    "Grain",
    "Grèce",
    "Grenade",
    "Grue",
    "Guerre",
    "Guide",
    "Herbe",
    "Héros",
    "Himalaya",
    "Histoire",
    "Hiver",
    "Hollywood",
    "Hôpital",
    "Hôtel",
    "Indien",
    "Iris",
    "Jet",
    "Jeu",
    "Jour",
    "Journal",
    "Jumelles",
    "Jungle",
    "Kangourou",
    "Kiwi",
    "Lait",
    "Langue",
    "Laser",
    "Lentille",
    "Lettre",
    "Licorne",
    "Lien",
    "Ligne",
    "Lion",
    "Liquide",
    "Lit",
    "Livre",
    "Londres",
    "Louche",
    "Lumière",
    "Lune",
    "Lunettes",
    "Luxe",
    "Machine",
    "Magie",
    "Main",
    "Maîtresse",
    "Majeur",
    "Maladie",
    "Manche",
    "Manège",
    "Marche",
    "Marin",
    "Marque",
    "Marron",
    "Mars",
    "Membre",
    "Mémoire",
    "Menu",
    "Meuble",
    "Microscope",
    "Miel",
    "Millionnaire",
    "Mine",
    "Mineur",
    "Mode",
    "Molière",
    "Mort",
    "Mouche",
    "Moule",
    "Mousse",
    "Moustache",
    "Nain",
    "Napoléon",
    "Neige",
    "New-York",
    "Ninja",
    "Noël",
    "Noeud",
    "Noir",
    "Note",
    "Nuit",
    "Numéro",
    "Oeil",
    "Oeuf",
    "Oiseau",
    "Opéra",
    "Opération",
    "Or",
    "Orange",
    "Ordre",
    "Page",
    "Paille",
    "Palais",
    "Palme",
    "Papier",
    "Parachute",
    "Paris",
    "Partie",
    "Passe",
    "Patron",
    "Pêche",
    "Pendule",
    "Pensée",
    "Perle",
    "Peste",
    "Pétrole",
    "Phare",
    "Physique",
    "Piano",
    "Pièce",
    "Pied",
    "Pigeon",
    "Pile",
    "Pilote",
    "Pingouin",
    "Pirate",
    "Place",
    "Plage",
    "Plan",
    "Planche",
    "Plante",
    "Plat",
    "Plateau",
    "Plume",
    "Poêle",
    "Point",
    "Poire",
    "Poisson",
    "Pôle",
    "Police",
    "Pomme",
    "Pompe",
    "Portable",
    "Pouce",
    "Prêt",
    "Princesse",
    "Prise",
    "Pyramide",
    "Quartier",
    "Queue",
    "Radio",
    "Raie",
    "Rame",
    "Rat",
    "Rayon",
    "Recette",
    "Règle",
    "Reine",
    "Religieuse",
    "Remise",
    "Requin",
    "Résistance",
    "Restaurant",
    "Révolution",
    "Robe",
    "Robot",
    "Roi",
    "Rome",
    "Ronde",
    "Rose",
    "Rouge",
    "Rouleau",
    "Roulette",
    "Russie",
    "Sardine",
    "Satellite",
    "Scène",
    "Schtroumpf",
    "Science",
    "Sens",
    "Sept",
    "Serpent",
    "Siège",
    "Sirène",
    "Sol",
    "Soldat",
    "Soleil",
    "Solution",
    "Somme",
    "Sorcière",
    "Sortie",
    "Souris",
    "Table",
    "Tableau",
    "Talon",
    "Tambour",
    "Temple",
    "Temps",
    "Tennis",
    "Terre",
    "Tête",
    "Timbre",
    "Titre",
    "Toile",
    "Tokyo",
    "Tour",
    "Trait",
    "Trésor",
    "Trou",
    "Tube",
    "Tuile",
    "Uniforme",
    "Vaisseau",
    "Vampire",
    "Vase",
    "Vent",
    "Verre",
    "Vert",
    "Vie",
    "Vin",
    "Visage",
    "Vision",
    "Voile",
    "Voiture",
    "Vol",
    "Voleur",
    "Volume",
    "Zéro"
  ])
];
